var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHierarchyMulticolor = function SvgIconHierarchyMulticolor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-hierarchy-tiny",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(0 12)",
    fill: "#ff8500"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(12 12)",
    fill: "#9b59b6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 6.667,
    height: 4,
    rx: 1,
    transform: "translate(4.667)",
    fill: "#1eaae1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 4,
    height: 4,
    rx: 1,
    transform: "translate(6 12)",
    fill: "#8ccd32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M579.333 206.879v-2.667a2 2 0 0 0-2-2h-4v-3.333H572v3.333h-4a2 2 0 0 0-2 2v2.667h1.333v-2.667a.667.667 0 0 1 .667-.667h4v3.333h1.333v-3.333h4a.667.667 0 0 1 .667.667v2.667Z",
    transform: "translate(-564.667 -194.879)",
    fill: "#bebebe"
  })));
};
export { SvgIconHierarchyMulticolor as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1oaWVyYXJjaHktdGlueSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yNyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMjciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHJ4PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDEyKSIgZmlsbD0iI2ZmODUwMCIvPgogIDxyZWN0IGlkPSJSZWN0YW5nbGVfMjgiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDI4IiB3aWR0aD0iNCIgaGVpZ2h0PSI0IiByeD0iMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIgMTIpIiBmaWxsPSIjOWI1OWI2Ii8+CiAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yOSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMjkiIHdpZHRoPSI2LjY2NyIgaGVpZ2h0PSI0IiByeD0iMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC42NjcpIiBmaWxsPSIjMWVhYWUxIi8+CiAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8zMCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMzAiIHdpZHRoPSI0IiBoZWlnaHQ9IjQiIHJ4PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2IDEyKSIgZmlsbD0iIzhjY2QzMiIvPgogIDxwYXRoIGlkPSJQYXRoXzEyMyIgZGF0YS1uYW1lPSJQYXRoIDEyMyIgZD0iTTU3OS4zMzMsMjA2Ljg3OXYtMi42NjdhMiwyLDAsMCwwLTItMmgtNHYtMy4zMzNINTcydjMuMzMzaC00YTIsMiwwLDAsMC0yLDJ2Mi42NjdoMS4zMzN2LTIuNjY3YS42NjcuNjY3LDAsMCwxLC42NjctLjY2N2g0djMuMzMzaDEuMzMzdi0zLjMzM2g0YS42NjcuNjY3LDAsMCwxLC42NjcuNjY3djIuNjY3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU2NC42NjcgLTE5NC44NzkpIiBmaWxsPSIjYmViZWJlIi8+Cjwvc3ZnPgo=";